export default __webpack_public_path__ + "static/media/heart-filled.b2fc1373.svg";